import type { paths } from "@/api-schema";
import { optionsWithDefaults } from "@/common/api/_helpers/options-with-defaults";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { Options } from "../../_types";

export const CASAVI_CONTACT_WHITELIST_BY_UUID_RESOURCE = "casavi-contact-whitelist" as const;
export const CASAVI_CONTACT_WHITELIST_BY_UUID_API_PATH =
  `/v1/${CASAVI_CONTACT_WHITELIST_BY_UUID_RESOURCE}/{uuid}` as const;

export type CasaviContactWhitelistByUuidParameters =
  paths[typeof CASAVI_CONTACT_WHITELIST_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type CasaviContactWhitelistByUuidResponse =
  paths[typeof CASAVI_CONTACT_WHITELIST_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useCasaviContactWhitelistByUuidQuery(
  uuid: string,
  options?: Options<CasaviContactWhitelistByUuidParameters, never>,
) {
  const optionsWithDefaultsResolved =
    optionsWithDefaults<Options<CasaviContactWhitelistByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [CASAVI_CONTACT_WHITELIST_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<CasaviContactWhitelistByUuidResponse>(
        `/v1/${CASAVI_CONTACT_WHITELIST_BY_UUID_RESOURCE}/${uuid}`,
        {
          params: requestParameters,
        },
      );

      return response.data;
    },
  });
}
